/**
 * Generated runtime TestId mirror for frontend/src/pages/ApprovalPolicyDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ApprovalPolicyDetailTestIds = {
  approvalPolicyDetailPage: "approval-policy-detail-page",
  badgePolicyType: "badge-policy-type",
  btnDelete: "btn-delete",
  btnEdit: "btn-edit",
  cardPolicyDetails: "card-policy-details",
  cardTitlePolicyConditions: "card-title-policy-conditions",
  cardTitlePolicySteps: "card-title-policy-steps",
  colApprovalStrategy: "col-approval-strategy",
  colField: "col-field",
  colOperator: "col-operator",
  colRequired: "col-required",
  colResolverParam: "col-resolver-param",
  colResolverType: "col-resolver-type",
  colStepOrder: "col-step-order",
  colValue: "col-value"
} as const;
